/** Navigation only. Identity verification and credential replacement remain in recovery. */
export function AccountRecoveryOption({ onRecover, disabled = false }: { onRecover: () => void; disabled?: boolean }) {
  return <div className="space-y-1 text-center">
    <button type="button" disabled={disabled} onClick={onRecover} className="text-sm font-medium text-primary underline-offset-2 hover:underline disabled:opacity-50">
      Recover your account
    </button>
    <p className="text-xs text-muted-foreground">
      If none of your sign-in methods work, verify your identity to set up a new passkey.
    </p>
  </div>;
}
